import { bumpAssetCacheVersion } from './assetCache';

const STORAGE_KEYS = [
  'vb_token',
  'vb_user_id',
  'vb_last_auth_at',
  'vb_settings',
  'vb_locale',
  'vb_guest_popup_seen_at',
  'vb_device_id',
];

const SESSION_KEYS = [
  'vb_guest_popup_seen',
  'vb_logo_config',
];

export const STORAGE_CLEAR_KEY = 'vb_storage_clear_v';
/** Bump this to force-clear cookies/storage for every visitor once. */
export const STORAGE_CLEAR_VERSION = '20260907b1';

function clearCookiesHard() {
  try {
    const hostname = window.location.hostname || '';
    const parts = hostname.split('.').filter(Boolean);
    const domains = new Set(['', hostname]);
    if (parts.length >= 2) {
      domains.add(`.${parts.slice(-2).join('.')}`);
    }
    if (parts.length >= 3) {
      domains.add(`.${parts.slice(-3).join('.')}`);
    }
    document.cookie.split(';').forEach((part) => {
      const name = part.split('=')[0]?.trim();
      if (!name) return;
      for (const domain of domains) {
        const domainPart = domain ? `;domain=${domain}` : '';
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${domainPart}`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Secure;SameSite=Lax${domainPart}`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Secure;SameSite=None${domainPart}`;
      }
    });
  } catch {
    /* ignore */
  }
}

export async function clearSiteStorage() {
  STORAGE_KEYS.forEach((key) => {
    try { localStorage.removeItem(key); } catch {}
  });
  SESSION_KEYS.forEach((key) => {
    try { sessionStorage.removeItem(key); } catch {}
  });
  try {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('vb_') && key !== STORAGE_CLEAR_KEY) localStorage.removeItem(key);
    });
  } catch {}
  try {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith('vb_')) sessionStorage.removeItem(key);
    });
  } catch {}

  clearCookiesHard();

  if ('caches' in window) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    } catch {}
  }

  bumpAssetCacheVersion();
}

export async function ensureForcedStorageClear() {
  if (typeof window === 'undefined') return false;
  let current = '';
  try {
    current = localStorage.getItem(STORAGE_CLEAR_KEY) || '';
  } catch {}
  if (current === STORAGE_CLEAR_VERSION) return false;

  await clearSiteStorage();

  try {
    localStorage.setItem(STORAGE_CLEAR_KEY, STORAGE_CLEAR_VERSION);
  } catch {}

  try {
    const flag = 'vb_storage_clear_reload';
    if (sessionStorage.getItem(flag) === STORAGE_CLEAR_VERSION) return true;
    sessionStorage.setItem(flag, STORAGE_CLEAR_VERSION);
  } catch {}

  try {
    window.location.reload();
  } catch {}
  return true;
}
